import { isNil } from 'lodash-es';
import { matchPath as matchPathBase } from 'react-router-dom';

import { RestrictedRoutes } from './RouteMiddleware';

export const matchPath = (
  routesPattern: ReadonlyArray<RestrictedRoutes>,
  pathname: string,
) => {
  for (const pattern of routesPattern) {
    const match = matchPathBase(pattern, pathname);

    if (!isNil(match)) {
      return {
        params: match.params,
        pattern,
      };
    }
  }

  return undefined;
};
